import { Injectable, OnDestroy } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';

import { Router } from '@angular/router';
import { environment } from '../../../../../environments/environment';
import { HttpMethodsService } from '../_helpers/http-methods.service';
import { PendingUserConstants } from '../pendingUsers/constants/pendingUsers.constant';
import { ProfileAPI } from '../profile_api/constants/profile.constant';

@Injectable({
  providedIn: 'root'
})
export class WebsocketService implements OnDestroy {
  triggerProfileDashboard = new Subject<any>();
  callProfileDashboard = this.triggerProfileDashboard.asObservable();
  deviceReportWebSocketURL = webSocket(environment.deviceReportWebSocket);
  deviceDashboardWebSocketURL = webSocket(environment.deviceDashboardWebSocket);
  profileDashboardWebSocketURL = webSocket(environment.webSocket);
  stdPkgWebSocketURL = webSocket(environment.stdPkgWebSocketURL);//IIT2-5802
  private webSocketConnection: WebSocketSubject<any>;
  private websocketUrl = `${environment.webSocket}`;

  private ngUnsubscribe = new Subject<boolean>();

  constructor(
    private router: Router,
    private httpMethod: HttpMethodsService
    ) { }

  connectWebSocket() {
    this.webSocketConnection = webSocket(this.websocketUrl);

    return this.webSocketConnection;
  }

  send(): void {
    const USERID = sessionStorage.getItem(PendingUserConstants.USER_ID);
    const bodyData = {userId : USERID};
    if (this.webSocketConnection) {
      this.webSocketConnection.next(bodyData);
    } else {
      this.webSocketConnection.error(err => err);
    }
  }

  closeConnection(): void {
    if (this.webSocketConnection) {
      this.webSocketConnection.complete();
      this.webSocketConnection = null ;
    }
  }

  updateUserConnectionId(connectionId: string) {
    const url = `${PendingUserConstants .SLASH_USER_MANAGEMENT}${PendingUserConstants.SLASH_USER}${PendingUserConstants.SLASH}`;
    const bodyData = {
      connectionID : connectionId
    };

    return this.httpMethod.patch(url, JSON.stringify(bodyData))
    .pipe(map((res: any) =>
    res));
  }

  ngOnDestroy() {
    this.closeConnection();
  }
}
